<template>
	<div class="pronto-removable">
		<slot />
		<div class="pronto-remove-button" @click="emit('remove')">
			<CloseIcon type="solid" />
		</div>
	</div>
</template>

<script setup>
import { CloseIcon } from '@/icons'
import { computed } from 'vue'
const emit = defineEmits(['remove'])
const props = defineProps({
	top: {
		type: Number,
		default: -6,
	},
	right: {
		type: Number,
		default: -6,
	},
})

const topPx = computed(() => props.top + 'px')
const rightPx = computed(() => props.right + 'px')
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.pronto-removable {
	position: relative;
	.pronto-remove-button {
		--size: 24px;
		width: var(--size);
		height: var(--size);
		@include flex-center;
		cursor: pointer;
		position: absolute;
		top: v-bind(topPx);
		right: v-bind(rightPx);
		background: var(--neutral-600);
		color: var(--neutral-100);
		border: 2px solid var(--neutral-100);
		border-radius: 50%;
		> .pronto-icon {
			font-size: 12px;
		}
	}
}
</style>
